import React from 'react';

import './button.scss';

const ButtonOne = () => {
  return (
        <a href="https://photo.kochfoto.com/Art-Prints" target="_blank" rel="noopener noreferrer" className="btn-action">
            Fine Art | Large Prints
        </a>
  );
}

export default ButtonOne;